/// <amd-module name="Wit/WorkItemForm/Details/WorkItemFormCommentPreview" />
import { MarkdownPreviewWithAutocomplete } from "Mention/MarkdownWithAutocomplete/Components";
import * as React from "react";
import { IMarkdownPreviewProps } from "VSS/Features/MarkdownEditor/Components";
import { css } from "VSSUI/Util";

export type WorkItemFormCommentPreviewProps = IMarkdownPreviewProps & {
    content: string;
};

export const WorkItemFormCommentPreview: React.FC<WorkItemFormCommentPreviewProps> = props => (
    <MarkdownPreviewWithAutocomplete
        refreshThrottleMs={500}
        {...props}
        className={css("markdown-preview", props.className)}
        options={{ html: true, breaks: true, clickableImages: true, ...props.options }}
        value={props.content}
    />
);
